import { render, staticRenderFns } from "./DoughnutChartLanguagesShort.vue?vue&type=template&id=763defc4&scoped=true&"
import script from "./DoughnutChartLanguagesShort.vue?vue&type=script&lang=js&"
export * from "./DoughnutChartLanguagesShort.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutChartLanguagesShort.vue?vue&type=style&index=0&id=763defc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763defc4",
  null
  
)

export default component.exports